import { ContactForm } from '../components/ContactForm';
import { useState } from 'react';
import FadeIn from '../components/FadeIn';

function Contact() {
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = () => {
    setIsSubmitted(true);
  };

  if (isSubmitted) {
    return (
    <div className="flex flex-col items-center w-full max-w-[1200px] p-4 mx-auto">
      <FadeIn>
      <h1 className="text-6xl font-bold text-brand text-center py-10">Thank you for your message!</h1>
      </FadeIn>
      <FadeIn delay={0.25}>
      <p className="text-brand-dark text-center text-xl mb-12">We will get back to you as soon as possible.</p>
      </FadeIn>
    </div>
    );
  }

  return (
    <>
      <title>Contact vidi3D - Get Started with Virtual Tours & 3D Visualization</title>
      <meta name="description" content="Connect with vidi3D's team of 3D visualization experts. Let's discuss your virtual tour needs and create an immersive experience for your space." />
      <meta name="keywords" content="contact vidi3D, virtual tour consultation, 3D visualization services, venue technology solutions" />
      <meta property="og:title" content="Contact vidi3D - Get Started with Virtual Tours & 3D Visualization" />
      <meta property="og:description" content="Ready to transform your space? Connect with vidi3D's experts to discuss virtual tours and 3D visualization solutions tailored to your needs." />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={`${process.env.PUBLIC_URL}/images/banner01.jpg`} />
      <link rel="canonical" href="https://vidi3d.com/contact" />
      <div className="flex flex-col items-center w-full max-w-[1200px] p-4 mx-auto">
        <FadeIn>
        <h1 className="text-6xl font-bold text-brand text-center py-10">Get in Touch</h1>
        </FadeIn>
        <FadeIn delay={0.25}>
        <p className="text-brand-dark text-center text-xl mb-12">Ready to transform your space into an immersive virtual experience? We'd love to hear from you and discuss how we can help bring your vision to life.</p>
        </FadeIn>
        <FadeIn className="w-full max-w-lg" delay={0.5}>
        <ContactForm onSuccess={handleSubmit} />
        </FadeIn>
      </div>
    </>
  );
}

export default Contact;